/**
 * [微企收款单表单弹窗]
 * @author: Fu Xiaochun
 * @date: 2021-09-04 
 */

import React, { useEffect, useState } from 'react';
import styles from './CollectionOrderModal.module.scss';
import { Modal, Button, Select, Input, InputNumber, DatePicker, message } from 'antd';
import PropTypes from 'prop-types';
import { priceUppercase, regFenToYuan, regYuanToFen } from '@/util/money';
import { UploadOutlined } from '@ant-design/icons';
import moment from 'moment';
import CusotmUpload, { generateFileList } from '@/components/NewUpload';
import * as api from '@/apis/finance/microcollectionmanage';
import { getEnum } from '@/apis/common/index';

const { Option } = Select;


function CollectionOrderModal(props){

    const [msg, setMsg] = useState({});
    const [enterprises, setEnterprises] = useState([]);
    const [businessTypes, setBusinessTypes] = useState([]);
    const [payMethods, setPayMethods] = useState([]);
    const [enterprisesDetail, setEnterprisesDetail] = useState({});
    const [fileList, setFileList] = useState([]);

    const [payCompany, setPayCompany] = useState({value: ''});
    const [payCompanyId, setPayCompanyId] = useState();
    const [payCompanyName, setPayCompanyName] = useState();
    const [payTotalAmount, setPayTotalAmount] = useState('');
    const [receiveDate, setReceiveDate] = useState(moment());
    const [businessType, setBusinessType] = useState();
    const [payMethod, setPayMethod] = useState();
    const [payContent, setPayContent] = useState('');
    const [payUser, setPayUser] = useState();
    const [annexUrl, setAnnexUrl] = useState();

    const [detail, setDetail] = useState(null);

    useEffect(()=>{
        getMicroBusinessList();
        getBizEnum();
        getPayMethods();
    }, []);

    useEffect(()=>{
        props.detail && setDetail(props.detail);
        if(props.detail){
            let detail = props.detail;
            setDetail(detail);
            setPayCompany({label: detail.payCompanyName, value: detail.payCompanyId});
            setPayCompanyId(detail.payCompanyId);
            setPayCompanyName(detail.payCompanyName);
            getEnterpriseDetail(detail.payCompanyId);
            setPayTotalAmount(regFenToYuan(detail.payTotalAmount));
            setReceiveDate(moment(detail.setReceiveDate));
            setBusinessType(detail.businessType);
            setPayMethod(detail.payMethod);
            setPayContent(detail.payContent);
            setPayUser(detail.payUser);
            setAnnexUrl(detail.annexUrl);
            setFileList([{url: detail.annexUrl, name: detail.annexUrl}]);
        }
    }, [props.detail]);

    // 业务类型枚举
    const getBizEnum = ()=>{
        getEnum({enumName: 'SettleReceiptBusinessEnum'}).then(res=>{
            setBusinessTypes(res.result);
        }).catch(err=>{
            message.error(err.message);
        });
    };

    // 支付方式枚举
    const getPayMethods = ()=>{
        getEnum({enumName: 'SettleReceiptPayMethodEnum'}).then(res=>{
            setPayMethods(res.result);
        }).catch(err=>{
            message.error(err.message);
        });
    };

    // 微企列表
    const getMicroBusinessList = ()=>{
        api.microBusinessList().then(res=>{
            setEnterprises(res.result.dataList);
        }).catch(err=>{
            message.error(err.message);
        });
    };

    const title = props.detail ? '编辑收款单' : '新建收款单';

    const onEnterpriseChange = (data)=>{
        setPayCompany(data);
        setPayCompanyId(data.value);
        setPayCompanyName(data.label);
        getEnterpriseDetail(data.value);
        setMsg({...msg, payCompanyId: ''});
    };

    const getEnterpriseDetail = (id)=>{
        api.microBusinessDetail({id}).then(res=>{
            setEnterprisesDetail(res.result);
        }).catch(err=>{
            message.error(err.message);
        });
    };

    const onPaymentChange = (val)=>{
        if(val != ''){
            setMsg({...msg, payTotalAmount: ''});
        }
        setPayTotalAmount(val);
    };

    const onPaymentBlur = (e)=>{
        setPayTotalAmount(e.target.value);
    };
    
    const onBusinessTypeChange = (val)=>{
        setBusinessType(val);
    };
    
    const onPayMethodsChange = (val)=>{
        setPayMethod(val);
    };

    const onPayContentChange = (e)=>{
        let val = e.target.value.trim();
        setPayContent(val);
    };

    const onPayUserChange = (e)=>{
        let val = e.target.value.trim();
        setPayUser(val);
    };

    const onAttachmentChange = (e)=>{
        setFileList(e.fileList);
        let temp = [];
        e.fileList.forEach(v=>{
            if(v.url){
                temp.push(v.url);
                return;
            }
        });
        setAnnexUrl(temp[0]);
    };

    const validate = ()=>{
        let status = true;
        let tips = {...msg};

        if(!payCompanyId){
            status = false;
            tips = {...tips, payCompanyId: '请选择交款企业'};
        }else{
            tips = {...tips, payCompanyId: ''};
        }

        if(payTotalAmount < 1){
            status = false;
            tips = {...tips, payTotalAmount: '交款总额不能低于1元'};
        }else if(payTotalAmount == ''){
            status = false;
            tips = {...tips, payTotalAmount: '请选输入交款总额'};
        }else{
            tips = {...tips, payTotalAmount: ''};
        }

        if(!receiveDate){
            status = false;
            tips = {...tips, receiveDate: '请选择交款日期'};
        }else{
            tips = {...tips, receiveDate: ''};
        }

        if(!businessType){
            status = false;
            tips = {...tips, businessType: '请选择业务类型'};
        }else{
            tips = {...tips, businessType: ''};
        }

        if(!payMethod){
            status = false;
            tips = {...tips, payMethod: '请选择支付方式'};
        }else{
            tips = {...tips, payMethod: ''};
        }

        if(!payContent){
            status = false;
            tips = {...tips, payContent: '请选输入交款内容'};
        }else if(payContent.length > 300){
            status = false;
            tips = {...tips, payContent: '交款内容不要超过300字符长度'};
        }else{
            tips = {...tips, payContent: ''};
        }

        if(!payUser){
            status = false;
            tips = {...tips, payUser: '请输入缴款人'};
        }else{
            tips = {...tips, payUser: ''};
        }

        setMsg(tips);
        return status;
    };

    const onOk = ()=>{
        if(!validate()){
            return false;
        }
        let formData = {
            payCompanyId,
            payCompanyName,
            payTotalAmount: regYuanToFen(payTotalAmount),
            receiveTotalAmount: regYuanToFen(payTotalAmount),
            receiveDate: receiveDate.format('YYYY-MM-DD 00:00:00'),
            businessType,
            payMethod,
            payContent,
            payUser,
            annexUrl
        };

        if(props.detail && props.detail.id){
            formData.receiptId = props.detail.id;
            // update
            api.updateCollectionOrder(formData).then(res=>{
                message.success('更新成功');
                props.onSave();
            }).catch(err=>{
                message.error(err.message);
            });
        }else{
            // create
            api.addCollectionOrder(formData).then(res=>{
                message.success('创建成功');
                props.onSave();
            }).catch(err=>{
                message.error(err.message);
            });
        }
        
    };

    const onClose = ()=>{
        props.onClose();
    };

    return (
        <Modal title={title} visible={true} onOk={onOk} onCancel={onClose} width={700} bodyStyle={{width: '700px', maxHeight: '700px', overflowY: 'auto', padding: '30px'}}>
            <div className={styles.formBox}>
                <div>
                    <div className={styles.formItem}>
                        <div className={styles.label}><span>*</span>交款单位名称：</div>
                        <div className={styles.info}>
                            <Select
                                showSearch
                                style={{ width: '100%' }}
                                placeholder="请选择"
                                optionFilterProp="label"
                                onChange={onEnterpriseChange}
                                filterOption={(input, option) =>option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                labelInValue={true}
                                value={payCompany}
                            >{enterprises.map(v=><Option key={v.id} value={v.id}>{v.epName}</Option>)}
                            </Select>
                            <div className={styles.tips}>{msg.payCompanyId ? <><i>!</i>{msg.payCompanyId}</> : null}</div>
                        </div>
                    </div>
                    <div className={styles.formItem}>
                        <div className={styles.label}>&nbsp;</div>
                        <div className={styles.info}>
                            <div className={styles.infoItem}>开户行：<span>{enterprisesDetail.a || '-'}</span></div>
                            <div className={styles.infoItem}>地址：<span>{enterprisesDetail.epRegisterAddr || '-'}</span></div>
                            <div className={styles.infoItem}>对公账户：<span>{enterprisesDetail.a || '-'}</span></div>
                            <div className={styles.infoItem}>姓名/电话：{enterprisesDetail.id 
                                ? (<><span>{enterprisesDetail.nickname}</span> / <span>{enterprisesDetail.tel}</span></>)
                                : '-/-'
                            }
                            </div>
                        </div>
                    </div>
                    <div className={styles.formItem}>
                        <div className={styles.label}>账户余额：</div>
                        <div className={styles.info}>{
                            enterprisesDetail.id 
                            ? `￥${regFenToYuan(enterprisesDetail.accountBalance)} (${priceUppercase(regFenToYuan(enterprisesDetail.accountBalance))})`
                            : '- (-)'
                        }</div>
                    </div>
                    <div className={styles.formItemWrap}>
                        <div className={styles.formItem}>
                            <div className={styles.label}><span>*</span>交款总额：</div>
                            <div className={styles.info}>
                                <InputNumber className={styles.txt} value={payTotalAmount} onChange={onPaymentChange} onBlur={onPaymentBlur} max={999999.99} min={1} precision={2} />
                                {msg.payTotalAmount ? null : <div className={styles.upcase}>{priceUppercase(payTotalAmount)}</div>}
                                <div className={styles.tips}>{msg.payTotalAmount ? <><i>!</i>{msg.payTotalAmount}</> : null}</div>
                            </div>
                        </div>
                        <div className={styles.formItem}>
                            <div className={styles.label}>收款日期：</div>
                            <div className={styles.info}>
                                <DatePicker defaultValue={receiveDate} onChange={setReceiveDate} placeholder='请选择' showTime={false} className={styles.txt} />
                                <div className={styles.tips}>{msg.receiveDate ? <><i>!</i>{msg.receiveDate}</> : null}</div>
                            </div>
                        </div>
                    </div>
                    <div className={styles.formItemWrap}>
                        <div className={styles.formItem}>
                            <div className={styles.label}><span>*</span>业务类型：</div>
                            <div className={styles.info}>
                                <Select
                                    showSearch
                                    style={{ width: '100%' }}
                                    placeholder="请选择"
                                    optionFilterProp="children"
                                    onChange={onBusinessTypeChange}
                                    filterOption={(input, option) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                    value={businessType}
                                >{businessTypes.map(v=><Option key={v.code} value={v.code}>{v.value}</Option>)}
                                </Select>
                                <div className={styles.tips}>{msg.businessType ? <><i>!</i>{msg.businessType}</> : null}</div>
                            </div>
                        </div>
                        <div className={styles.formItem}>
                            <div className={styles.label}><span>*</span>交款方式：</div>
                            <div className={styles.info}>
                                <Select
                                    showSearch
                                    style={{ width: '100%' }}
                                    placeholder="请选择"
                                    optionFilterProp="children"
                                    onChange={onPayMethodsChange}
                                    filterOption={(input, option) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                    value={payMethod}
                                >{payMethods.map(v=><Option key={v.code} value={v.code}>{v.value}</Option>)}
                                </Select>
                                <div className={styles.tips}>{msg.payMethod ? <><i>!</i>{msg.payMethod}</> : null}</div>
                            </div>
                        </div>
                    </div>
                    <div className={styles.formItem}>
                        <div className={styles.label}><span>*</span>交款内容：</div>
                        <div className={styles.info}>
                            <Input.TextArea className={styles.txts} value={payContent} onChange={onPayContentChange} />
                            <div style={{width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                                <div className={styles.tips}>{msg.payContent ? <><i>!</i>{msg.payContent}</> : null}</div>
                                <div className={styles.strLen}>{payContent.length}/300</div>
                            </div>
                        </div>
                    </div>
                    <div className={styles.formItem}>
                        <div className={styles.label}><span>*</span>缴款人：</div>
                        <div className={styles.info}>
                            <Input className={styles.txt} value={payUser} onChange={onPayUserChange} />
                            <div className={styles.tips}>{msg.payUser ? <><i>!</i>{msg.payUser}</> : null}</div>
                        </div>
                    </div>
                    <div className={styles.formItem}>
                        <div className={styles.label}>上传附件：</div>
                        <div className={styles.info}>
                            <CusotmUpload
                                maxCount={1}
                                accept='.doc, .docx, .pdf, .jpg, .png'
                                removeError
                                fileList={fileList}
                                onFileListChange={onAttachmentChange}
                                qiniuUploadProps={{ uploadType: 'image' }}
                                beforeUpload={file => {
                                    let type = (file.name || '').replace(/.+\./g, '.');
                                    const isType = ['.doc', '.docx', '.pdf', '.jpg', '.png'];
                                    const isGt3M = file.size / 1024 / 1024 > 3;
                                    if (!isType.includes(type)) {
                                        message.warn('只能上传 .doc, .docx, .pdf, .jpg, .png 格式的文件!');
                                        file.status = 'error';
                                        return false;
                                    }
                                    if (isGt3M) {
                                        message.warn('图片必须小于 3M!');
                                        file.status = 'error';
                                        return false;
                                    }
                                }}
                            >
                                <Button icon={<UploadOutlined />} style={{ marginBottom: 5 }}>上传文件</Button>
                            </CusotmUpload>
                            <div className={styles.tips}>支持扩展名：.doc .docx .pdf .jpg .png</div>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    );
}

CollectionOrderModal.propTypes = {
    onSave: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    detail: PropTypes.object,
};

export default CollectionOrderModal;